module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-12.7a8dd582.png";